<template>
  <div v-if="Object.keys(holiday_data).length > 0">
    <b-modal id="exodus-holiday-info-modal" ref="exodus-holiday-info-modal-ref" hide-footer title="Trip Information">
      <div class="modal-banner-container" v-if="holiday_data.images.length > 0">
        <img :src="holiday_data.images[0].file" class="vtd-center-image" />
        <div class="modal-banner-text">{{ holiday_data.holiday.name }}</div>
      </div>
      <div>
        <h4 class="mt-3 orange">Introduction</h4>
        <p class="text-left" v-html="holiday_data.holiday.overview"></p>
      </div>
      <div class="row">
        <div v-if="holiday_data.holiday.countries.length === 1" class="col-md-4 vtd-font-weight-bold">
          Region:
        </div>
        <div v-if="holiday_data.holiday.countries.length > 1" class="col-md-4 vtd-font-weight-bold">
          Regions:
        </div>
        <div class="col-md-8">
          <span v-for="(country, index) in holiday_data.holiday.countries" :key="index">{{ country
          }}<span v-if="index !== holiday_data.holiday.countries.length - 1">,
            </span></span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">Start City:</div>
        <div class="col-md-8">{{ holiday_data.holiday.start_city }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">End City:</div>
        <div class="col-md-8">{{ holiday_data.holiday.finish_city }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">Duration:</div>
        <div class="col-md-8">
          {{ holiday_data.holiday.duration.period }}
          {{ holiday_data.holiday.duration.type }}
        </div>
      </div>
      <div v-if="holiday_data.holiday.themes" class="row">
        <div v-if="holiday_data.holiday.themes.length === 1" class="col-md-4 vtd-font-weight-bold">
          Theme:
        </div>
        <div v-if="holiday_data.holiday.themes.length > 1" class="col-md-4 vtd-font-weight-bold">
          Themes:
        </div>
        <div class="col-md-8">
          <span v-for="(theme, index) in holiday_data.holiday.themes" :key="index">{{ theme
          }}<span v-if="index !== holiday_data.holiday.themes.length - 1">,
            </span></span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">Trip Code:</div>
        <div class="col-md-8">{{ holiday_data.holiday.trip_code }}</div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">Group Size:</div>
        <div class="col-md-8">
          <span v-if="holiday_data.holiday.group_size.min">Min: {{ holiday_data.holiday.group_size.min }}</span><span
            v-if="
              holiday_data.holiday.group_size.min &&
              holiday_data.holiday.group_size.max
            ">, </span><span v-if="holiday_data.holiday.group_size.max">Max: {{ holiday_data.holiday.group_size.max
            }}</span>
        </div>
      </div>
      <div v-if="holiday_data.holiday.physical_rating" class="row">
        <div class="col-md-4 vtd-font-weight-bold">Physical Rating:</div>
        <div class="col-md-8" v-html="holiday_data.holiday.physical_rating" />
      </div>
      <div v-if="holiday_data.meals" class="row">
        <div class="col-md-4 vtd-font-weight-bold">Meals:</div>
        <div class="col-md-8">
          <span v-if="holiday_data.meals.breakfast > 0">
            {{ holiday_data.meals.breakfast }}
            <span v-if="holiday_data.meals.breakfast === 1">Breakfast</span>
            <span v-if="holiday_data.meals.breakfast > 1">Breakfasts</span></span>
          <span v-if="
            (holiday_data.meals.breakfast && holiday_data.meals.lunch) ||
            (holiday_data.meals.breakfast && holiday_data.meals.dinner)
          ">,
          </span>
          <span v-if="holiday_data.meals.lunch > 0">
            {{ holiday_data.meals.lunch }}
            <span v-if="holiday_data.meals.lunch === 1">Lunch</span>
            <span v-if="holiday_data.meals.lunch > 1">Lunches</span></span>
          <span v-if="holiday_data.meals.lunch && holiday_data.meals.dinner">,
          </span>
          <span v-if="holiday_data.meals.dinner > 0">
            {{ holiday_data.meals.dinner }}
            <span v-if="holiday_data.meals.dinner === 1">Dinner</span>
            <span v-if="holiday_data.meals.dinner > 1">Dinners</span></span>
        </div>
      </div>
      <div v-if="holiday_data.holiday.accommodation" class="row">
        <div class="col-md-4 vtd-font-weight-bold">Accommodation:</div>
        <div class="col-md-8" v-html="holiday_data.holiday.accommodation" />
      </div>

      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">Minimum Age:</div>
        <div class="col-md-8">{{ holiday_data.holiday.min_age }}</div>
      </div>
      <div v-if="holiday_data.holiday.map">
        <h4 class="mt-3 orange">Trip Map</h4>
        <img :src="holiday_data.holiday.map" class="vtd-center-image" />
      </div>
      <h4 class="mt-3 orange">Itinerary</h4>
      <div v-for="obj in holiday_data.itinerary" v-bind:key="obj.day" class="itinerary-container">
        <h6 class="orange">Day {{ obj.day }}</h6>
        <p v-html="obj.action.replace(/([A-Z](?!\s|[A-Z]))/g, ' $1').trim()" />
        <div class="inclusion-container" v-if="obj.meals">
          <h5 class="vtd-font-weight-bold">Meals:</h5>
          <p>
            {{ obj.meals }}
          </p>
        </div>
        <div class="inclusion-container" v-if="obj.accommodation">
          <h5 class="vtd-font-weight-bold">Accommodation:</h5>
          <p v-html="obj.accommodation" />
        </div>
        <div v-if="obj.optional_activities">
          <h5 class="vtd-font-weight-bold">Optional Activities:</h5>
          <ul>
            <li v-for="(activity, index) in obj.optional_activities" :key="index">
              {{ activity }}
            </li>
          </ul>
        </div>
      </div>
      <template>
        <div>
          <h4 class="mt-3 orange">Gallery</h4>
          <b-carousel id="carousel-1" v-model="slide" :interval="0" controls indicators background="#ffffff"
            @sliding-start="onSlideStart" @sliding-end="onSlideEnd" class="carousel-height">
            <b-carousel-slide v-for="(image, index) in holiday_data.images" :key="index">
              <template #img>
                <img :src="image.file" :loading="index === 0 ? 'eager' : 'lazy'" decoding="async"
                  class="gallery-image" alt="" />
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>
      </template>
      <div>
        <h4 class="mt-3 orange">Trip Notes</h4>
        <div>
          <div v-if="holiday_data.trip_notes.right_for_you">
            <h5 class="mt-3 vtd-font-weight-bold">Right For You</h5>
            <p v-html="holiday_data.trip_notes.right_for_you"></p>
          </div>
          <div v-if="holiday_data.trip_notes.accommodation">
            <h5 class="mt-3 vtd-font-weight-bold">Accommodation</h5>
            <p v-html="holiday_data.trip_notes.accommodation.replace(/([A-Z](?!\s|[A-Z]))/g, ' $1').trim()" />
            <!-- <p>
              {{
                holiday_data.trip_notes.accommodation
                  .replace(/([A-Z](?!\s|[A-Z]))/g, " $1")
                  .trim()
              }}
            </p> -->
          </div>
          <div v-if="holiday_data.trip_notes.transportation">
            <h5 class="mt-3 vtd-font-weight-bold">Transportation</h5>
            <p>
              {{
                holiday_data.trip_notes.transportation
                  .replace(/([A-Z](?!\s|[A-Z]))/g, " $1")
                  .trim()
              }}
            </p>
          </div>
          <div v-if="holiday_data.trip_notes.transfer_details">
            <h5 class="mt-3 vtd-font-weight-bold">Transfer Details</h5>
            <p>
              {{
                holiday_data.trip_notes.transfer_details
                  .replace(/([A-Z](?!\s|[A-Z]))/g, " $1")
                  .trim()
              }}
            </p>
          </div>
          <div v-if="holiday_data.trip_notes.meals">
            <h5 class="mt-3 vtd-font-weight-bold">Meals</h5>
            <p>
              {{
                holiday_data.trip_notes.meals
                  .replace(/([A-Z](?!\s|[A-Z]))/g, " $1")
                  .trim()
              }}
            </p>
          </div>
          <div v-if="holiday_data.trip_notes.group">
            <h5 class="mt-3 vtd-font-weight-bold">Group</h5>
            <p>
              {{
                holiday_data.trip_notes.group
                  .replace(/([A-Z](?!\s|[A-Z]))/g, " $1")
                  .trim()
              }}
            </p>
          </div>
          <div v-if="holiday_data.trip_notes.climate">
            <h5 class="mt-3 vtd-font-weight-bold">Climate</h5>
            <p>
              {{
                holiday_data.trip_notes.climate
                  .replace(/([A-Z](?!\s|[A-Z]))/g, " $1")
                  .trim()
              }}
            </p>
          </div>
          <div v-if="holiday_data.trip_notes.when_to_go">
            <h5 class="mt-3 vtd-font-weight-bold">Best Time To Go</h5>
            <p>
              {{
                holiday_data.trip_notes.when_to_go
                  .replace(/([A-Z](?!\s|[A-Z]))/g, " $1")
                  .trim()
              }}
            </p>
          </div>
          <div v-if="holiday_data.trip_notes.essential_equipment">
            <h5 class="mt-3 vtd-font-weight-bold">Essential Equipment</h5>
            <p>
              {{
                holiday_data.trip_notes.essential_equipment
                  .replace(/([A-Z](?!\s|[A-Z]))/g, " $1")
                  .trim()
              }}
            </p>
          </div>
          <div v-if="holiday_data.trip_notes.optional_equipment">
            <h5 class="mt-3 vtd-font-weight-bold">Optional Equipment</h5>
            <p>
              {{
                holiday_data.trip_notes.optional_equipment
                  .replace(/([A-Z](?!\s|[A-Z]))/g, " $1")
                  .trim()
              }}
            </p>
          </div>
          <div v-if="holiday_data.trip_notes.money">
            <h5 class="mt-3 vtd-font-weight-bold">Money</h5>
            <p>{{ holiday_data.trip_notes.money }}</p>
          </div>
          <div v-if="holiday_data.trip_notes.tipping">
            <h5 class="mt-3 vtd-font-weight-bold">Tipping</h5>
            <p>{{ holiday_data.trip_notes.tipping }}</p>
          </div>
          <div v-if="holiday_data.trip_notes.exclusions">
            <h5 class="mt-3 vtd-font-weight-bold">Exclusions</h5>
            <ul>
              <li v-for="(exclusion, index) in holiday_data.trip_notes.exclusions" :key="index">
                {{ exclusion }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
// import { fetchExodusData } from "../../modules/booking/tours/services";
export default {
  props: {
    item: null,
    holiday_data: {},
  },
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  computed: {
    returnDays() {
      if (
        this.holiday_data &&
        this.holiday_data.itinerary &&
        Array.isArray(this.holiday_data.itinerary)
      ) {
        return this.holiday_data.itinerary.length;
      }
      return "";
    },
  },
  methods: {
    show(htlpagelink) {
      this.$refs["exodus-holiday-info-modal-ref"].show();
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
};
</script>

<style scoped>
.modal-banner-container {
  position: relative;
  text-align: center;
  color: white;
  height: 30rem;
  overflow: hidden;
}

.modal-banner-text {
  font-size: 3vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}

.itinerary-container {
  border: 1px solid black;
  margin-top: 10px;
  padding: 10px;
}

.inclusion-container {
  background-color: #dbdbdb;
  margin: 10px;
  padding: 10px;
}

.address {
  text-indent: 40px;
}

.carousel-height {
  height: 40vh;
  overflow: hidden;
}

.carousel-height ::v-deep .carousel-inner,
.carousel-height ::v-deep .carousel-item {
  height: 100%;
}

.gallery-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
}

.vtd-center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.vtd-font-weight-bold {
  font-weight: bolder;
}

.orange {
  color: orange;
  font-weight: bolder;
}
</style>